import { useParams } from 'react-router-dom';
import { useContracts } from '../../../../../../../../Hooks/TT_ELD/Contracts';
import ContractsTable from './ContractTable';

type params = {
  readonly id: any;
};

const Contract = () => {
  const { id } = useParams<params>();

  const { data, refetch, isLoading } = useContracts(1, 'accepted', id, 'platform');

  return (
    <div className="mainPage">
      <ContractsTable data={data?.data} isLoading={isLoading} refetch={refetch} />
    </div>
  );
};

export default Contract;
